<div class="flex flex-col h-full max-w-4xl w-full max-h-[90vh]">
    <!-- Header -->
    <div class="flex flex-row justify-between items-center pb-4 border-b border-gray-200 dark:border-gray-700">
        <div class="flex flex-row items-center space-x-3">
            @if (isFullSuccess()) {
                <mat-icon class="text-green-600 dark:text-green-400 icon-size-6" svgIcon="heroicons_outline:check-circle"></mat-icon>
                <span class="text-lg font-semibold">Importação Concluída com Sucesso</span>
            } @else if (isFullFailure()) {
                <mat-icon class="text-red-600 dark:text-red-400 icon-size-6" svgIcon="heroicons_outline:x-circle"></mat-icon>
                <span class="text-lg font-semibold">Importação com Erros</span>
            } @else {
                <mat-icon class="text-yellow-600 dark:text-yellow-400 icon-size-6" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
                <span class="text-lg font-semibold">Importação Parcialmente Concluída</span>
            }
        </div>
        <button mat-icon-button mat-dialog-close>
            <mat-icon svgIcon="heroicons_outline:x-circle"></mat-icon>
        </button>
    </div>

    <!-- Statistics Cards -->
    <div class="grid grid-cols-3 gap-4 my-6">
        <!-- Total -->
        <div class="flex flex-col p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
            <div class="flex flex-row items-center space-x-2 mb-2">
                <mat-icon class="text-gray-600 dark:text-gray-400 icon-size-5" svgIcon="heroicons_outline:document-text"></mat-icon>
                <span class="text-sm font-medium text-gray-600 dark:text-gray-400">Total Processado</span>
            </div>
            <span class="text-2xl font-bold text-gray-900 dark:text-gray-100">{{ result().totalCount }}</span>
        </div>

        <!-- Success -->
        <div class="flex flex-col p-4 bg-green-50 dark:bg-green-900/20 rounded-lg border border-green-200 dark:border-green-800">
            <div class="flex flex-row items-center space-x-2 mb-2">
                <mat-icon class="text-green-600 dark:text-green-400 icon-size-5" svgIcon="heroicons_outline:check-circle"></mat-icon>
                <span class="text-sm font-medium text-green-700 dark:text-green-300">Sucesso</span>
            </div>
            <span class="text-2xl font-bold text-green-900 dark:text-green-100">{{ result().successCount }}</span>
        </div>

        <!-- Errors -->
        <div class="flex flex-col p-4 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800">
            <div class="flex flex-row items-center space-x-2 mb-2">
                <mat-icon class="text-red-600 dark:text-red-400 icon-size-5" svgIcon="heroicons_outline:x-circle"></mat-icon>
                <span class="text-sm font-medium text-red-700 dark:text-red-300">Erros</span>
            </div>
            <span class="text-2xl font-bold text-red-900 dark:text-red-100">{{ result().errorCount }}</span>
        </div>
    </div>

    <!-- Processing Time -->
    @if (result().processingTime) {
        <div class="flex flex-row items-center justify-end mb-4">
            <span class="text-xs text-gray-500 dark:text-gray-400">
                Tempo de processamento: {{ result().processingTime }}
            </span>
        </div>
    }

    <!-- Success and Errors Section -->
    <div class="flex flex-col space-y-4 overflow-y-auto" style="max-height: 500px;">
        <!-- Success Section -->
        @if (hasSuccesses()) {
            <div class="flex flex-col space-y-2">
                <div class="flex flex-row items-center justify-between">
                    <div class="flex flex-row items-center space-x-2">
                        <mat-icon class="text-green-600 dark:text-green-400" svgIcon="heroicons_outline:check-circle"></mat-icon>
                        <span class="font-medium text-green-800 dark:text-green-300">
                            {{ result().successCount }} usuário(s) importado(s) com sucesso
                        </span>
                    </div>
                </div>

                <mat-accordion class="w-full">
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="flex flex-row items-center space-x-2">
                                    <mat-icon class="icon-size-5 text-green-600 dark:text-green-400" svgIcon="heroicons_outline:check-circle"></mat-icon>
                                    <span>Usuários Importados</span>
                                    <span class="text-gray-500 dark:text-gray-400">({{ result().successCount }})</span>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        
                        <div class="space-y-2 pt-2">
                            @for (success of result().successes; track success.email + success.rowNumber) {
                                <div class="p-3 bg-green-50 dark:bg-green-900/10 rounded border border-green-200 dark:border-green-800">
                                    <div class="flex flex-row items-start space-x-2">
                                        <mat-icon class="icon-size-5 text-green-600 dark:text-green-400 mt-0.5" svgIcon="heroicons_outline:check-circle"></mat-icon>
                                        <div class="flex flex-col flex-1">
                                            <div class="flex flex-row items-center space-x-2 mb-1">
                                                <span class="font-medium text-green-800 dark:text-green-300">Linha {{ success.rowNumber }}</span>
                                                <span class="text-green-600 dark:text-green-400">•</span>
                                                <span class="text-green-700 dark:text-green-400 font-medium">{{ success.email }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        }

        <!-- Errors Section -->
        @if (hasErrors()) {
            <div class="flex flex-col space-y-2">
                <div class="flex flex-row items-center justify-between">
                    <div class="flex flex-row items-center space-x-2">
                        <mat-icon class="text-red-600 dark:text-red-400" svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                        <span class="font-medium text-red-800 dark:text-red-300">
                            {{ result().errorCount }} erro(s) encontrado(s)
                        </span>
                    </div>
                </div>

                <!-- Grouped Errors -->
                <mat-accordion class="w-full">
                    @for (group of groupedErrors(); track group.type) {
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <div class="flex flex-row items-center space-x-2">
                                        <mat-icon class="icon-size-5 text-red-600 dark:text-red-400" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
                                        <span>{{ group.type }}</span>
                                        <span class="text-gray-500 dark:text-gray-400">({{ group.count }})</span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            
                            <div class="space-y-2 pt-2">
                                @for (error of group.errors; track error.email + error.rowNumber) {
                                    <div class="p-3 bg-red-50 dark:bg-red-900/10 rounded border border-red-200 dark:border-red-800">
                                        <div class="flex flex-row items-start space-x-2">
                                            <mat-icon class="icon-size-5 text-red-600 dark:text-red-400 mt-0.5" svgIcon="heroicons_outline:x-circle"></mat-icon>
                                            <div class="flex flex-col flex-1">
                                                <div class="flex flex-row items-center space-x-2 mb-1">
                                                    <span class="font-medium text-red-800 dark:text-red-300">Linha {{ error.rowNumber }}</span>
                                                    <span class="text-red-600 dark:text-red-400">•</span>
                                                    <span class="text-red-700 dark:text-red-400 font-medium">{{ error.email }}</span>
                                                </div>
                                                <p class="text-sm text-red-700 dark:text-red-300">{{ error.error }}</p>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </mat-expansion-panel>
                    }
                </mat-accordion>
            </div>
        }
    </div>

    <!-- Action Buttons -->
    <div class="flex flex-row justify-end space-x-3 pt-4 mt-4 border-t border-gray-200 dark:border-gray-700">
        <button mat-flat-button color="primary" (click)="onCloseClick()">
            <span>Fechar</span>
        </button>
    </div>
</div>

